import { render, staticRenderFns } from "./desktopSelect.vue?vue&type=template&id=808367d4&"
import script from "./desktopSelect.vue?vue&type=script&lang=ts&"
export * from "./desktopSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports